import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge } from 'reactstrap';

export default class SidebarCategory extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isNew: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    collapse: PropTypes.bool,
  };

  static defaultProps = {
    icon: '',
    isNew: false,
    collapse: false
  };

  constructor(props) {
    super(props);
    const storageKey = `sidebar_${props.title}`;
    const stored = localStorage.getItem(storageKey);
    this.state = {
      collapse: stored !== null ? stored === 'true' : this.props.collapse
    };
  }

  toggle = () => {
    this.setState(prevState => {
      const next = !prevState.collapse;
      localStorage.setItem(`sidebar_${this.props.title}`, String(next));
      return { collapse: next };
    });
  };

  render() {
    const {
      title, icon, isNew, children
    } = this.props;
    const { collapse } = this.state;
    const categoryClass = classNames({
      'sidebar__category-wrap': true,
      'sidebar__category-wrap--open': collapse,
    })
//    console.log(this.state,this.props);
    return (
      <div className={categoryClass}>
        <button type="button" className="sidebar__link sidebar__category" onClick={this.toggle}>
          {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
          <p className="sidebar__link-title">{title}
            {isNew && <Badge className="sidebar__link-badge"><span>New</span></Badge>}
          </p>
          <span className="sidebar__category-icon lnr lnr-chevron-right" />
        </button>
        <Collapse isOpen={collapse} className="sidebar__submenu-wrap">
          <ul className="sidebar__submenu">
            <div>
              {children}
            </div>
          </ul>
        </Collapse>
      </div>
    );
  }
}
